

























































import Vue from 'vue'
import { mapGetters } from 'vuex'
import { ModuleNames } from '@/store/module-names'
import { AppGetterNames } from '@/store/modules/app/keys'
import { INCLUDE_MAP } from '@/constants/app-variables'

export default Vue.extend({
  data() {
    return {
      openDrawer: false,
      logoutRoute: { name: 'Logout', to: { name: 'logout' } },
      menuHideClass: INCLUDE_MAP ? 'd-xl-none' : 'd-md-none',
      menuWrapperClass: INCLUDE_MAP ? 'px-xl-8' : 'px-md-8',
      shouldIncludeDrawer:
        (INCLUDE_MAP && this.$vuetify.breakpoint.name !== 'xl') ||
        this.$vuetify.breakpoint.name === 'xs' ||
        this.$vuetify.breakpoint.name === 'sm',
    }
  },
  computed: {
    ...mapGetters(ModuleNames.app, {
      userFullName: AppGetterNames.userFullName,
    }),
  },
})
